// extracted by mini-css-extract-plugin
export default {"brandPromo":"FJ-z","carousel":"GJ-z"};